import { CheckCircle, Clock, MapPin, PackageSearch } from "lucide-react";
import { motion } from "framer-motion";
import { useContext, useEffect, useState } from "react";
import { MyContext } from "../../context/MyContext";
import axios from "axios";
import { useParams } from "react-router-dom";

const statusSteps = ["Ordered", "Shipped", "Out for Delivery", "Delivered"];



const ShippingDetails = ({ order = defaultOrder }) => {
  const { id } = useParams();
const { MLMStatus, verifyMlmUser } = useContext(MyContext);


  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [orderDetail, setOrderDetail] = useState([]);

  const userId = localStorage.getItem("userId");
  useEffect(() => {
    // Define async function inside the useEffect
    const fetchOrder = async () => {
      try {
      const response = await axios.get(`https://api.ourmicrolife.com/api/user/order/${id}`)
        console.log("-------------------------------->", response);
      } catch (error) {
        console.error("Error fetching data:", error);
        setError("Failed to fetch orders. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchOrder();
    if (userId) {
      fetchOrder();
    }
  }, [userId]);
  const getStatusClass = (step) => {
    const statusIndex = statusSteps.indexOf(order.status);
    const stepIndex = statusSteps.indexOf(step);
    return stepIndex <= statusIndex ? "text-blue-600" : "text-gray-300";
  };

  const isDelivered = order.status === "Delivered";

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-100 to-gray-200 flex items-center justify-center p-4 sm:p-6 pt-4 md:pt-2 lg:pt-40">
      <div className="w-full max-w-6xl bg-white/70 backdrop-blur-md rounded-3xl shadow-xl p-6 sm:p-8 space-y-8">
        <h2 className="text-2xl sm:text-3xl font-bold text-center text-gray-800">📦 Track Your Order</h2>

        {/* Items Section */}
        <div className="flex items-center gap-2 text-lg sm:text-xl font-semibold text-gray-700">
          <div className="text-blue-600">
            <PackageSearch />
          </div>
          <span>Items in Your Order</span>
        </div>
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {order.items.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              className="flex items-center gap-4 bg-white rounded-xl shadow p-4 hover:scale-105 transition"
            >
              <img
                src={item.image}
                alt={item.name}
                className="w-20 h-20 sm:w-24 sm:h-24 rounded-lg object-cover"
              />
              <div className="flex-1">
                <p className="font-semibold text-sm sm:text-lg">{item.name}</p>

                <p className="text-xs sm:text-sm text-gray-500">Seller: {item.seller}</p>
                <p className="text-xs sm:text-sm text-gray-500">Seller: {item.seller}</p>
                <p className="text-xs sm:text-sm text-gray-500">{item.variant}</p>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Order Progress */}
        <div className="flex items-center gap-2 text-lg sm:text-xl font-semibold text-gray-700">
          <div className="text-blue-600">
            <Clock />
          </div>
          <span>Order Status</span>
        </div>
        <div className="flex flex-wrap justify-between items-center gap-4 sm:gap-0">
          {statusSteps.map((step, idx) => (
            <div key={step} className="flex flex-col items-center text-center w-1/4 sm:w-auto">
              <div className="relative flex items-center justify-center mb-2">
                <div
                  className={`w-8 h-8 sm:w-10 sm:h-10 rounded-full border-4 ${getStatusClass(
                    step
                  )} border-dashed`}
                />
                {statusSteps.indexOf(order.status) >= idx && (
                  <CheckCircle className="absolute w-5 h-5 sm:w-6 sm:h-6 text-blue-600" />
                )}
              </div>
              <p className={`text-xs sm:text-sm font-medium ${getStatusClass(step)}`}>{step}</p>
              {order.timestamps?.[step] && (
                <p className="text-xs text-gray-500">{formatDate(order.timestamps[step])}</p>
              )}
            </div>
          ))}
        </div>

        {/* Address Section */}
        <div className="flex items-center gap-2 text-lg sm:text-xl font-semibold text-gray-700">
          <div className="text-blue-600">
            <MapPin />
          </div>
          <span>Shipping Address</span>
        </div>
        <div className="bg-white rounded-lg p-4 shadow-md space-y-1 text-sm sm:text-base">
          <p className="font-medium">{order.shippingAddress.name}</p>
          <p>{order.shippingAddress.address}</p>
          <p>{order.shippingAddress.phone}</p>
        </div>

        {/* Price Details */}
        <div className="flex items-center gap-2 text-lg sm:text-xl font-semibold text-gray-700">
          <span>Price Summary</span>
        </div>
        <div className="bg-white rounded-lg p-4 shadow-md space-y-2 text-gray-800 text-sm sm:text-base">
          <p>Subtotal: ₹{order.subtotal}</p>
          <p>Shipping: ₹{order.shipping}</p>
          <p className="font-bold text-lg">Total: ₹{order.total}</p>
        </div>

        {/* Download Button */}
        <div className="text-center pt-4">
          <motion.button
            whileHover={{ scale: 1.05 }}
            onClick={() => downloadInvoice(order.id)}
            disabled={!isDelivered}
            className={`px-4 py-2 sm:px-6 sm:py-3 rounded-full font-semibold shadow transition duration-300 ${isDelivered
              ? "bg-gradient-to-r from-blue-500 to-blue-700 text-white hover:shadow-lg"
              : "bg-gray-300 text-gray-600 cursor-not-allowed"
              }`}
          >
            {isDelivered ? "Download Invoice" : "Invoice available after delivery"}
          </motion.button>
        </div>
      </div>
    </div>
  );
};

const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString("en-IN", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
};

const downloadInvoice = (orderId) => {
  alert(`Invoice for Order #${orderId} is being downloaded...`);
};

const defaultOrder = {
  id: "ORD123456",
  status: "Out for Delivery",
  items: [
    {
      image:
        "https://assets.myntassets.com/w_412,q_60,dpr_2,fl_progressive/assets/images/17091614/2022/2/18/779ac019-8b8c-48f7-9c5e-b3e2fe3004b01645166457327-Men-White-Casual-Shirt-5731645166456476-1.jpg",
      name: "Classic White Shirt",
      seller: "Fashion Hub",
      variant: "Size: M, Color: White",
    },
    {
      image:
        "https://assets.myntassets.com/dpr_1.5,q_60,w_400,c_limit,fl_progressive/assets/images/2025/MARCH/5/GV1YtDyY_64549a0c48e14963ae80eb0e01d0e89e.jpg",
      name: "Denim Jeans",
      seller: "Denim World",
      variant: "Size: 32, Color: Blue",
    },
  ],
  timestamps: {
    Ordered: "2025-04-20",
    Shipped: "2025-04-21",
    "Out for Delivery": "2025-04-23",
  },
  shippingAddress: {
    name: "Divya Kapoor",
    address: "123, MG Road, Bangalore, India",
    phone: "+91-9876543210",
  },
  subtotal: 1998,
  shipping: 50,
  total: 2048,
};

export default ShippingDetails;

